import React from "react";
import { StarRating } from "components";

const stringToColor = (str) => {
  let hash = 0;

  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  const hue = Math.abs(hash) % 360;
  return `hsl(${hue}, 70%, 50%)`;
}

const createInitialAvatar = (
  name,
  size = 100,
  textColor = "#ffffff",
  fontFamily = "Arial, sans-serif",
) => {
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;

  const ctx = canvas.getContext("2d");
  if (!ctx) return "";

  const bgColor = stringToColor(name || "?");

  // Background
  ctx.fillStyle = bgColor;
  ctx.fillRect(0, 0, size, size);

  const firstLetter = name?.trim()?.charAt(0)?.toUpperCase() || "?";

  const fontSize = size * 0.6;
  ctx.font = `${fontSize}px ${fontFamily}`;
  ctx.fillStyle = textColor;
  ctx.textAlign = "center";

  // 🔑 Use font metrics for true vertical centering
  const metrics = ctx.measureText(firstLetter);
  const x = size / 2;
  const y =
    size / 2 +
    (metrics.actualBoundingBoxAscent - metrics.actualBoundingBoxDescent) / 2;

  ctx.fillText(firstLetter, x, y);

  return canvas.toDataURL("image/png");
};

const ReviewItem = ({ review }) => {
  const [initialAvatar, setInitialAvatar] = React.useState(null);
  const [readMoreText, setReadMoreText] = React.useState(false);

  const handleReadMoreText = () => {
    setReadMoreText(!readMoreText);
  };

  return (
    <li key={review?.id} className="flex gap-2 shadow-md rounded-md border p-4">
      <img
        loading="lazy"
        src={initialAvatar || review?.profile_photo_url}
        alt={review?.author_name}
        onError={() => {
          const initialAvatar = createInitialAvatar(review?.author_name);
          setInitialAvatar(initialAvatar);
        }}
        className="w-10 h-10 me-3 rounded-full"
      />
      <div className="flex-1 flex flex-col gap-2 w-full">
        <div className="flex justify-between items-center gap-2 flex-wrap">
          <span className="text-16x font-bold text-brand-base-primary">
            {review?.author_name}
          </span>
          <StarRating rating={review?.rating} />
        </div>
        <p>
          {readMoreText ? review?.text : review?.text?.slice(0, 100) + "..."}
          {review?.text?.length > 100 && (
            <span
              onClick={handleReadMoreText}
              className="ms-1 cursor-pointer text-brand-base-primary font-semibold"
            >
              {readMoreText ? "Read Less" : "Read More"}
            </span>
          )}
        </p>
      </div>
    </li>
  );
};

const OrdersFeedback = ({ reviewsInfo }) => {
  return (
    <>
      <br />
      <ul className="flex flex-col gap-2 px-4">
        {reviewsInfo?.reviews?.map((review) => (
          <ReviewItem key={review?.id} review={review} />
        ))}
      </ul>
    </>
  );
};

export default OrdersFeedback;
